import React from 'react'
import { Svg, Path, type SvgProps } from 'react-native-svg'

const CashOutPointsIcon = (props: SvgProps) => (
  <Svg width={49} height={49} viewBox="0 0 49 49" fill="none" {...props}>
    <Path
      d="M22.5 30.5H26.5C27.5609 30.5 28.5783 30.0786 29.3284 29.3284C30.0786 28.5783 30.5 27.5609 30.5 26.5C30.5 25.4391 30.0786 24.4217 29.3284 23.6716C28.5783 22.9214 27.5609 22.5 26.5 22.5H20.5C19.3 22.5 18.3 22.9 17.7 23.7L6.5 34.5"
      stroke="#223843"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M14.5 42.5001L17.7 39.7001C18.3 38.9001 19.3 38.5001 20.5 38.5001H28.5C30.7 38.5001 32.7 37.7001 34.1 36.1001L43.3 27.3001C44.0718 26.5707 44.5222 25.5646 44.5522 24.5032C44.5822 23.4417 44.1893 22.4118 43.46 21.6401C42.7307 20.8683 41.7246 20.4178 40.6631 20.3878C39.6017 20.3578 38.5718 20.7507 37.8 21.4801L29.4 29.2801"
      stroke="#223843"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M4.5 32.5L16.5 44.5"
      stroke="#223843"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M32.5 24.3C35.7032 24.3 38.2999 21.7032 38.2999 18.5C38.2999 15.2967 35.7032 12.7 32.5 12.7C29.2967 12.7 26.7 15.2967 26.7 18.5C26.7 21.7032 29.2967 24.3 32.5 24.3Z"
      fill="#00DFC9"
      stroke="#223843"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M12.5 16.5C15.8137 16.5 18.5 13.8137 18.5 10.5C18.5 7.18629 15.8137 4.5 12.5 4.5C9.18629 4.5 6.5 7.18629 6.5 10.5C6.5 13.8137 9.18629 16.5 12.5 16.5Z"
      fill="#00DFC9"
      stroke="#223843"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
)

export default CashOutPointsIcon
